import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.string.includes";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { createBairunStationBasePrice, deleteBairunStationBasePrice as _deleteBairunStationBasePrice, deleteBairunStationBasePriceByIds, updateBairunStationBasePrice, findBairunStationBasePrice, getBairunStationBasePriceList } from '@/api/bairun/stationBasePrice'; //  此处请自行替换地址

import { getStationBaseInfoList, getProvinceList } from '@/api/bairun/stationBaseInfo'; //  此处请自行替换地址

import * as DateUtil from '@/utils/date';
import infoList from '@/mixins/infoList';
import { getDict } from '@/utils/dictionary'; // 获取字典数据的func

var _this;

export default {
  name: 'BairunStationBasePrice',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return DateUtil.formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    formatOilCodeText: function formatOilCodeText(text) {
      if (text != null) {
        return text + '#';
      } else {
        return '';
      }
    },
    formatStationPriceText: function formatStationPriceText(text) {
      if (text != null) {
        return text.toFixed(2);
      } else {
        return '';
      }
    }
  },
  mixins: [infoList],
  data: function data() {
    var _this2 = this;

    var checkStationId = function checkStationId(rule, value, callback) {
      if (value === '') {
        callback(new Error('请选择一个油站'));
      } else {
        callback();
      }
    };

    var checkStationPrice = function checkStationPrice(rule, value, callback) {
      if (value <= 3) {
        callback(new Error('输入油站挂牌价太小'));
      } else {
        callback();
      }
    };

    var checkStartTime = function checkStartTime(rule, value, callback) {
      if (_this2.formData.whenStartRadio === 'later' && _this2.formData.startTime == null) {
        callback(new Error('请设置生效时间'));
      } else {
        callback();
      }
    };

    return {
      listApi: getBairunStationBasePriceList,
      oilCodeDict: getDict('oilCode'),
      priceEnableDict: getDict('priceEnable'),
      stateDict: getDict('state'),
      addDialogVisible: false,
      updateDialogVisible: false,
      dialogFormTitle: '',
      type: '',
      deleteVisible: false,
      // oilCodeDefaultShow: "全部",
      multipleSelection: [],
      oilCodeOptions: [],
      stateOptions: [],
      stationList: [],
      stationSearchOptions: [],
      stationTempOptions: [],
      provinceOptions: [],
      provinceIdChecked: [],
      stationCheckAll: false,
      stationIdChecked: [],
      formData: {
        stationId: '',
        oilCode: 92,
        stationPrice: 0,
        startTime: new Date().Format('yyyy-MM-dd hh:mm:ss'),
        state: 0,
        sysUserId: 0,
        sysUserName: '',
        whenStartRadio: 'now'
      },
      rules: {
        oilCode: [{
          required: true,
          message: '请选择油品',
          trigger: 'blur'
        }],
        whenStartRadio: [{
          required: true,
          message: '请选择生效时间',
          trigger: 'blur'
        }],
        stationPrice: [{
          required: true,
          validator: checkStationPrice,
          trigger: 'blur'
        }],
        startTime: [{
          required: true,
          validator: checkStartTime,
          trigger: 'blur'
        }]
      },
      // 设置只能选择当前日期及之后的日期
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          // 如果没有后面的-8.64e7就是不可以选择今天的
          return time.getTime() < Date.now() - 8.64e7;
        }
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this3.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this4.getTableData();

              case 2:
                _this4.setoilCodeMap();

                _this4.setStateMap();

                _this4.setStationList();

                _context3.next = 7;
                return getProvinceList({
                  'dataType': 1,
                  'page': 1,
                  'pageSize': 9999
                });

              case 7:
                res = _context3.sent;
                _this4.provinceOptions = res.data.list;

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onChangeSearchProvince: function onChangeSearchProvince() {
      var _this5 = this;

      if (this.searchInfo.provinceId && this.searchInfo.provinceId > 0) {
        this.stationSearchOptions = this.stationList.filter(function (item) {
          return item.provinceId == _this5.searchInfo.provinceId;
        });
      } else {
        this.stationSearchOptions = this.stationList;
      }
    },
    onCheckedProvince: function onCheckedProvince() {
      var _this6 = this;

      if (this.provinceIdChecked.length > 0) {
        this.stationTempOptions = this.stationList.filter(function (item) {
          return _this6.provinceIdChecked.includes(item.provinceId);
        });
      } else {
        this.stationTempOptions = [];
      }
    },
    onCheckedStationAll: function onCheckedStationAll(val) {
      this.stationIdChecked = val ? this.stationTempOptions.map(function (w) {
        return w.ID;
      }) : [];
      this.stationCheckAll = this.stationIdChecked.length === this.stationTempOptions.length;
    },
    stationIdChecked: function stationIdChecked(value) {
      this.stationCheckAll = value.length === this.stationTempOptions.length;

      if (this.stationCheckAll) {
        this.onCheckedStationAll(true);
      }
    },
    onStartTimeSwitch: function onStartTimeSwitch() {
      if (this.formData.whenStartRadio === 'now') {
        this.formData.startTime = new Date().Format('yyyy-MM-dd hh:mm:ss');
      }

      if (this.formData.whenStartRadio === 'later') {
        this.formData.startTime = DateUtil.diffDate(1);
      }

      this.$forceUpdate();
    },
    onDeleteRow: function onDeleteRow(row) {
      var _this7 = this;

      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this7.deleteBairunStationBasePrice(row);
      }).catch(function (err) {});
    },
    onDelete: function onDelete() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var ids, res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                ids = [];

                if (!(_this8.multipleSelection.length === 0)) {
                  _context4.next = 4;
                  break;
                }

                _this8.$message({
                  type: 'warning',
                  message: '请选择要删除的数据'
                });

                return _context4.abrupt("return");

              case 4:
                _this8.multipleSelection && _this8.multipleSelection.map(function (item) {
                  ids.push(item.ID);
                });
                _context4.next = 7;
                return deleteBairunStationBasePriceByIds({
                  ids: ids
                });

              case 7:
                res = _context4.sent;

                if (!(res.code === 0)) {
                  _context4.next = 14;
                  break;
                }

                _this8.$message({
                  type: 'success',
                  message: '删除成功'
                });

                if (_this8.tableData.length === ids.length) {
                  _this8.page--;
                }

                _this8.deleteVisible = false;
                _context4.next = 14;
                return _this8.getTableData();

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onAdd: function onAdd() {
      this.type = 'create';
      this.addDialogVisible = true;
      this.onStartTimeSwitch();
    },
    onUpdate: function onUpdate(row) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return findBairunStationBasePrice({
                  ID: row.ID
                });

              case 2:
                res = _context5.sent;
                _this9.type = 'update';
                _this9.dialogFormTitle = '变更挂牌价';

                if (res.code === 0) {
                  _this9.formData = res.data.resBairunStationBasePrice;
                  _this9.formData.startTime = new Date(_this9.formData.startTime).Format('yyyy-MM-dd hh:mm:ss');
                  _this9.updateDialogVisible = true;
                  _this9.formData.whenStartRadio = 'later';
                }

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    closeDialog: function closeDialog() {
      this.$refs['formData'].resetFields();
      this.addDialogVisible = false;
      this.updateDialogVisible = false;
      this.stationTempOptions = [];
      this.provinceIdChecked = [];
      this.stationCheckAll = false;
      this.stationIdChecked = [];
      this.formData = {
        stationId: '',
        oilCode: 92,
        stationPrice: 0,
        startTime: new Date().Format('yyyy-MM-dd hh:mm:ss'),
        state: 0,
        sysUserId: 0,
        sysUserName: '',
        whenStartRadio: 'now'
      };
    },
    deleteBairunStationBasePrice: function deleteBairunStationBasePrice(row) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _deleteBairunStationBasePrice({
                  ID: row.ID
                });

              case 2:
                res = _context6.sent;

                if (res.code === 0) {
                  _this10.$message({
                    type: 'success',
                    message: '删除成功'
                  });

                  if (_this10.tableData.length === 1) {
                    _this10.page--;
                  }

                  _this10.getTableData();
                }

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    enterDialog: function enterDialog() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var that;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                that = _this11;

                _this11.$refs['formData'].validate(function (valid) {
                  if (valid) {
                    that.handleSuccess();
                  } else {
                    console.log('error submit!!');
                    return false;
                  }
                });

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    handleSuccess: function handleSuccess() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var res;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.t0 = _this12.type;
                _context8.next = _context8.t0 === 'create' ? 3 : _context8.t0 === 'update' ? 11 : 15;
                break;

              case 3:
                if (!(_this12.stationIdChecked.length == 0)) {
                  _context8.next = 6;
                  break;
                }

                _this12.$message({
                  type: 'error',
                  message: '请选择油站'
                });

                return _context8.abrupt("return");

              case 6:
                _this12.formData.stationIds = _this12.stationIdChecked;
                _context8.next = 9;
                return createBairunStationBasePrice(_this12.formData);

              case 9:
                res = _context8.sent;
                return _context8.abrupt("break", 16);

              case 11:
                _context8.next = 13;
                return updateBairunStationBasePrice(_this12.formData);

              case 13:
                res = _context8.sent;
                return _context8.abrupt("break", 16);

              case 15:
                return _context8.abrupt("break", 16);

              case 16:
                if (res.code === 0) {
                  _this12.$message({
                    type: 'success',
                    message: '创建/更改成功'
                  });

                  _this12.closeDialog('formData');

                  _this12.getTableData();
                }

              case 17:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    setoilCodeMap: function setoilCodeMap() {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return getDict('oilCode');

              case 2:
                _this13.oilCodeDict = _context9.sent;

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    setStateMap: function setStateMap() {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return getDict('state');

              case 2:
                _this14.stateDict = _context10.sent;

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }))();
    },
    // async setPriceEnableMap() {
    // 	this.priceEnableDict = await getDict('priceEnable');
    // },
    setStationList: function setStationList() {
      var _this15 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var res;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return getStationBaseInfoList({
                  page: 1,
                  pageSize: 999999
                });

              case 2:
                res = _context11.sent;

                if (res && res.code === 0 && res.data && res.data.list) {
                  _this15.stationList = res.data.list;
                }

                _this15.onChangeSearchProvince();

              case 5:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }))();
    }
  }
};